import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import { RecruitmentShowContentScoutMessageProps as Props } from './types';
import { fetchScoutMessage } from '../../../services/recruitments';
import { fetchScoutUnread } from '../../../services/people';
import { useModal } from '../../../hooks/useModal';

export const Component: FunctionComponent<Props> = (props) => {
  const [scoutMessagePlain, setScoutMessagePlain] = useState('');
  const [scoutMessageLinked, setScoutMessageLinked] = useState('');
  const [scoutId, setScoutId] = useState<number | null>(null);
  const { isOpen: isModalOpen, open, close: handleCloseModal } = useModal(false, {
    lockBody: true
  });

  useEffect(() => {
    const request = async () => {
      try {
        const response = await fetchScoutMessage(props.recruitmentId);
        setScoutMessagePlain(response.plainMessage);
        setScoutMessageLinked(response.linkedMessage);
        setScoutId(response.scoutId);
      } catch (error) {
        console.log(error);
      }
    };

    request();
  }, [props.recruitmentId]);

  const handleMoreClick = () => {
    open();
    if (!scoutId) return;
    updateScoutUnread();
  };

  const updateScoutUnread = async () => {
    try {
      if (!scoutId) return;
      await fetchScoutUnread(scoutId);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Presentation
      {...props}
      scoutMessagePlain={scoutMessagePlain}
      scoutMessageLinked={scoutMessageLinked}
      isModalOpen={isModalOpen}
      handleMoreClick={handleMoreClick}
      handleCloseModal={handleCloseModal}
    />
  );
};
